import { RequestType } from "@/types/busrequest";
/* was used for categorie markers 
const mdAccountBalance =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M8 20v14h6V20H8zm12 0v14h6V20h-6zM4 44h38v-6H4v6zm28-24v14h6V20h-6zM23 2L4 12v4h38v-4L23 2z"/></svg>';
const mdBuild =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M45.4 37.9L27.1 19.6c1.8-4.6.8-10.1-2.9-13.8-4-4-10-4.8-14.8-2.5l8.7 8.7-6.1 6.1-8.7-8.7C1 14.2 1.8 20.2 5.8 24.2c3.7 3.7 9.2 4.7 13.8 2.9l18.3 18.3c.8.8 2.1.8 2.8 0l4.7-4.7c.8-.7.8-2 0-2.8z"/></svg>';
const mdDirectionsBike =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M31 11c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zM10 24C4.5 24 0 28.5 0 34s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 17c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm11.6-19.9l4.7-4.8 1.5 1.5c2.5 2.6 6 4.1 10.1 4.1v-4c-3 0-5.5-1.1-7.3-2.9l-3.9-3.8c-.6-.7-1.6-1.2-2.7-1.2s-2.1.4-2.8 1.2l-5.5 5.5c-.7.7-1.2 1.7-1.2 2.8 0 1.1.5 2.1 1.2 2.9L22 28v10h4V25.5l-4.4-4.4zM38 24c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 17c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"/></svg>';
const mdLocalActivity =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M40 24c0-2.21 1.79-4 4-4v-8c0-2.21-1.79-4-4-4H8c-2.21 0-3.98 1.79-3.98 4l-.01 8C6.22 20.01 8 21.8 8 24c0 2.21-1.79 4-3.99 4L4 36c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4v-8c-2.21 0-4-1.79-4-4zm-8.84 9.6L24 29l-7.16 4.6L19 25.37l-6.58-5.38 8.49-.5L24 11.6l3.09 7.89 8.49.5L29 25.37l2.16 8.23z"/></svg>';
const mdLocalAirPort =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M42 32v-4L26 18V7c0-1.66-1.34-3-3-3s-3 1.34-3 3v11L4 28v4l16-5v11l-4 3v3l7-2 7 2v-3l-4-3V27l16 5z"/></svg>';
const mdLocalAtm =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M22 34h4v-2h2c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2h-6v-2h8v-4h-4v-2h-4v2h-2c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2h-8v4h4v2zM40 8H8c-2.21 0-3.98 1.79-3.98 4L4 36c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H8V12h32v24z"/></svg>';
const mdLocalDining =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M16.2 26.69l5.66-5.66L7.83 7c-3.12 3.12-3.12 8.19 0 11.31l8.37 8.38zm13.57-3.63c3.05 1.43 7.36.42 10.54-2.76 3.83-3.83 4.56-9.3 1.63-12.23C39 5.14 33.52 5.87 29.7 9.7c-3.18 3.18-4.18 7.49-2.76 10.54-4.45 4.44-19.53 19.52-19.53 19.52l2.83 2.83L24 28.83l13.76 13.76 2.83-2.83L26.83 26l2.94-2.94z"/></svg>';
const mdLocalGasstation =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M39.54 14.46l.03-.03L32.12 7 30 9.12l4.22 4.22C32.34 14.06 31 15.87 31 18c0 2.76 2.24 5 5 5 .71 0 1.39-.15 2-.42V37c0 1.1-.9 2-2 2s-2-.9-2-2v-9c0-2.21-1.79-4-4-4h-2V10c0-2.21-1.79-4-4-4H12c-2.21 0-4 1.79-4 4v32h20V27h3v10c0 2.76 2.24 5 5 5s5-2.24 5-5V18c0-1.38-.56-2.63-1.46-3.54zM24 20H12V10h12v10zm12 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>';
const mdLocalHotel =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M14 26c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm24-12H22v14H6V10H2v30h4v-6h36v6h4V22c0-4.42-3.58-8-8-8z"/></svg>';
const mdLocalMall =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M38 12h-4c0-5.52-4.48-10-10-10S14 6.48 14 12h-4c-2.21 0-3.98 1.79-3.98 4L6 40c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V16c0-2.21-1.79-4-4-4zM24 6c3.31 0 6 2.69 6 6H18c0-3.31 2.69-6 6-6zm0 20c-5.52 0-10-4.48-10-10h4c0 3.31 2.69 6 6 6s6-2.69 6-6h4c0 5.52-4.48 10-10 10z"/></svg>';
const mdLocalMovies =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M36 6v4h-4V6H16v4h-4V6H8v36h4v-4h4v4h16v-4h4v4h4V6h-4zM16 34h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm20 16h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4z"/></svg>';
const mdLocalOffer =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M42.82 23.16L24.83 5.17C24.1 4.45 23.1 4 22 4H8C5.79 4 4 5.79 4 8v14c0 1.11.45 2.11 1.18 2.83l18 18C23.9 43.55 24.9 44 26 44c1.1 0 2.11-.45 2.83-1.17l14-14C43.55 28.1 44 27.1 44 26c0-1.11-.45-2.11-1.18-2.84zM11 14c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/></svg>';
*/
const mdDirectionsBus =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M8 32c0 1.77.78 3.34 2 4.44V40c0 1.1.9 2 2 2h2c1.11 0 2-.9 2-2v-2h16v2c0 1.1.89 2 2 2h2c1.1 0 2-.9 2-2v-3.56c1.22-1.1 2-2.67 2-4.44V12c0-7-7.16-8-16-8S8 5 8 12v20zm7 2c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm18 0c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-12H12V12h24v10z"/></svg>';
const mdPerson =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M24 24c4.42 0 8-3.59 8-8 0-4.42-3.58-8-8-8s-8 3.58-8 8c0 4.41 3.58 8 8 8zm0 4c-5.33 0-16 2.67-16 8v4h32v-4c0-5.33-10.67-8-16-8z"/></svg>';
const mdReportProblem =
  '<svg width="28" height="28" viewBox="0 0 48 48" x="2px" y="2px"><path fill="white" d="M2 42h44L24 4 2 42zm24-6h-4v-4h4v4zm0-8h-4v-8h4v8z"/></svg>';
const emergencyPath =
  '<path class="emergency" fill="none" stroke="rgb(253, 117, 117)" stroke-width="3" d="M9,18 a9,9 0 0,1 -9,-9" />';
const emptyridePath =
  '<path class="emptyride" fill="none" stroke="rgb(248, 206, 107)" stroke-width="3" d="M18,9 a9,9 0 0,1 -9,9" />';
const vacancyPath =
  '<path class="vacancy" fill="none" stroke="rgb(87, 207, 201)" stroke-width="3" d="M9,0 a9,9 0 0,1 9,9" />';
const grouprequestPath =
  '<path class="grouprequest" fill="none" stroke="rgb(87, 207, 161)" stroke-width="3" d="M0,9 a9,9 0 0,1 9,-9" />';

const requestTypeClusterIcon: Record<RequestType, string> = {
  grouprequest: grouprequestPath,
  emergency: emergencyPath,
  emptyride: emptyridePath,
  vacancy: vacancyPath,
};

function svgToDataUrl(svg: string): string {
  const encoded = encodeURIComponent(svg)
    .replace(/'/g, "%27")
    .replace(/"/g, "%22");

  const header = "data:image/svg+xml,";
  const dataUrl = header + encoded;

  return dataUrl;
}

const requestTypeSingleIcon: Record<RequestType, string> = {
  grouprequest: mdPerson,
  emergency: mdReportProblem,
  emptyride: mdDirectionsBus,
  vacancy: mdDirectionsBus,
};

const requestTypeSingleColor: Record<RequestType, string> = {
  grouprequest: "rgb(87, 207, 161)",
  emergency: "rgb(253, 117, 117)",
  emptyride: "rgb(248, 206, 107)",
  vacancy: "rgb(87, 207, 201)",
};

export function calcBusrequestClusterIcon(types: RequestType[]): string {
  if (types.length === 1) {
    const svg = `<svg viewBox="0 0 32 44" xmlns="http://www.w3.org/2000/svg" width="32px" height="44px">
    <rect fill="${
      requestTypeSingleColor[types[0]]
    }" width="32px" height="32px" />
    ${requestTypeSingleIcon[types[0]]}
    <polygon fill="${
      requestTypeSingleColor[types[0]]
    }" points="6,32 16,44, 26,32"/>
    </svg>`;
    return svgToDataUrl(svg);
  } else {
    const svg = `<svg viewBox="-7 -7 32 32" xmlns="http://www.w3.org/2000/svg" width="64px" height="64px">
    <circle r="11" fill="white" stroke="black" stroke-width="1" cx="9" cy="9"/>
    <g>
        ${types.map((t) => requestTypeClusterIcon[t]).join("/n")}
    </g>
</svg>`;
    return svgToDataUrl(svg);
  }
}

export const advertiserLocationClusterIcon =
  svgToDataUrl(`<svg viewBox="-7 -7 32 32" xmlns="http://www.w3.org/2000/svg" width="64px" height="64px">
<circle r="11" fill="white" stroke="black" stroke-width="1" cx="9" cy="9"/>
<circle r="9" fill="none" stroke="rgb(133, 182, 224)" stroke-width="3" cx="9" cy="9"/>
</svg>`);

export const advertiserDafaultIcon =
  svgToDataUrl(`<svg viewBox="0 0 32 44" xmlns="http://www.w3.org/2000/svg" width="32px" height="44px">
  <rect fill="rgb(133, 182, 224)" width="32px" height="32px" />
  <polygon fill="rgb(133, 182, 224)" points="6,32 16,44, 26,32"/>
  </svg>`);
